export type ResizeAxes = 'vertical' | 'horizontal' | 'both'
export type ResizeCorner = 'left' | 'right'

export function getResizeCursor(axes: ResizeAxes, corner: ResizeCorner = 'right'): string {
  if (axes === 'vertical') return 'ns-resize'
  if (axes === 'horizontal') return 'ew-resize'
  return corner === 'left' ? 'nesw-resize' : 'nwse-resize'
}
